module.exports = __webpack_public_path__ + "img/agro_group.dd99fd44.png";